const createCell = (row, col) => ({
  row,
  col,
  id: `${row}-${col}`
});

const createSelectionState = () => ({
  startCell: null,
  endCell: null,
  isSelecting: false,
  activeRange: null
});

function updateRange(selection) {
  if (!selection.startCell || !selection.endCell) {
    selection.activeRange = null;
    return;
  }
  const startRow = Math.min(selection.startCell.row, selection.endCell.row);
  const endRow = Math.max(selection.startCell.row, selection.endCell.row);
  const startCol = Math.min(selection.startCell.col, selection.endCell.col);
  const endCol = Math.max(selection.startCell.col, selection.endCell.col);
  selection.activeRange = { startRow, endRow, startCol, endCol };
}

function isSelected(cell, range) {
  if (!range) return false;
  return (
    cell.row >= range.startRow &&
    cell.row <= range.endRow &&
    cell.col >= range.startCol &&
    cell.col <= range.endCol
  );
}

function isInRange(cell, range) {
  return isSelected(cell, range);
}

function getSelectedCells(rows, cols, range) {
  if (!range) return [];
  const cells = [];
  for (let r = range.startRow; r <= range.endRow; r++) {
    for (let c = range.startCol; c <= range.endCol; c++) {
      cells.push(createCell(r, c));
    }
  }
  return cells;
}

function copyToClipboard(grid, range, getCellValue) {
  if (!range) return '';
  const rows = [];
  for (let r = range.startRow; r <= range.endRow; r++) {
    const row = [];
    for (let c = range.startCol; c <= range.endCol; c++) {
      row.push(getCellValue(r, c));
    }
    rows.push(row);
  }
  return rows.map(row => row.join('\t')).join('\n');
}

function parseClipboardData(text) {
  if (!text || !text.trim()) return [];
  return text.split('\n').map(line => line.split('\t'));
}

export {
  createCell,
  createSelectionState,
  updateRange,
  isSelected,
  isInRange,
  getSelectedCells,
  copyToClipboard,
  parseClipboardData
};
